import React, { Component } from 'react';
import style from '../share/pageUpdate.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import DropDownWithLabel from '../../components/DropDownWithLabel';




import DefaultBtn from '../../components/DefaultBtn.js';
import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import axios from 'axios'
import BackDropLoading from '../../components/BackDropLoading.js';
import MultipleCheckedWithLabel from '../../components/MultipleCheckedWithLabel.js';
import * as utils from '../../Utils.js';
import uuid from 'react-uuid';


class CompanyUserControlUpdate extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            dataObject: null,
            userObject: null,
            companyId: this.props.companyId,
            validateObject: null,
            loading: true,
            policyOptions: null,
            costcenterOptions: null,
            employeeGroupOptions: null,

        };
        this.callGetData();
        //this.callGetPolicyOptions();
        //this.callGetCallCenterOptions();
        this.callGetEmployeeGroupOptions();

        //alert("test");
        //alert("CompanyUserControlUpdate");
       
    }



    callGetEmployeeGroupOptions() {
        //alert("test");
        let appState = this.props.appState;
        let companyId = appState.userObject.companyId;
        let token = this.props.appState.userObject.Token;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetEmployeeGroupOptions";
        let data = {
            Id: companyId
        }
        utils.callPost(url, token, data, this.callGetEmployeeGroupOptionsCallBack);
    }
    callGetEmployeeGroupOptionsCallBack = (res) => {
        //console.log("policy option debug");
        //console.log(res);
        this.setState({
            employeeGroupOptions: res.Data
        });
    }


    callGetPolicyOptions() {
        //alert("test");
        let appState = this.props.appState;
        let companyId = appState.userObject.companyId;
        let token = this.props.appState.userObject.Token;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetPolicyOptions";
        let data = {
            Id: companyId
        }
        utils.callPost(url, token, data, this.callGetPolicyOptionsCallBack);
    }
    callGetPolicyOptionsCallBack = (res) => {
        //console.log("policy option debug");
        //console.log(res);
        this.setState({
            policyOptions: res.Data
        });
    }



    callGetCallCenterOptions() {
        //alert("test");
        let appState = this.props.appState;
        let companyId = appState.userObject.companyId;
        let token = this.props.appState.userObject.Token;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetCostCenterOptions";
        let data = {
            Id: companyId
        }
        utils.callPost(url, token, data, this.callGetCallCenterOptionsCallBack);
    }
    callGetCallCenterOptionsCallBack = (res) => {
        //console.log("policy option debug");
        //console.log(res);
        this.setState({
            costcenterOptions: res.Data
        });
    }








    callGetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetUserCompanyData";
        let data = {
            Id: this.props.Id
        };

        let token = this.props.appState.userObject.Token;
        utils.callPost(url,token,data,this.callGetDataCallBack);
        this.setState({
            loading: true
        })
        
    }







    callGetDataCallBack=(res)=> {

        let data =res.Data;
        //console.log(data);
        this.setState({
            dataObject: { ...data.dataObject },
            validateObject: { ...data.validateObject },
            loading: false
        })
    }
    callSetData() {
        //alert("set data");
        let appState = this.props.appState;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/UpdateUserCompany";
        let data = { ...this.state.dataObject };
        data.CompanyId = appState.userObject.companyId;

        //alert(data.CompanyId);


        let token = this.props.appState.userObject.Token;
        utils.callPost(url,token,data,this.callSetDataCallBack);



        // axios
        //     .post(url, data, {
        //         headers: {
        //             'Authorization': appState.userObject.Token
        //         }
        //     })
        //     .then(response => {
        //         this.callSetDataCallBack(response.data);
        //     })
        //     .catch(err => {
        //         console.error(err)
        //     })

        this.setState({
            loading: true
        })
    }
    callSetDataCallBack=(data)=> {
        //console.log(data);

        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
            })
            this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
                dataObject: { ...data.Data.dataObject },
                validateObject: { ...data.Data.validateObject }
            })
        }
    }


    callDeleteData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/DeleteUserCompany";
        let data = { ...this.state.dataObject };
        let appState = this.props.appState;

        let token = appState.userObject.Token;
        utils.callPost(url,token,data,this.callDeleteDataCallBack);

        this.setState({
            loading: true
        })
    }
    callDeleteDataCallBack=(data)=> {
        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
            })
            this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
                dataObject: { ...data.Data.dataObject },
                validateObject: { ...data.Data.validateObject }
            })
        }
    }






    handleChange = (e) => {
        console.log(e);
        let dataObject = { ...this.state.dataObject };

        //if (e.target.name === "HotelCode") dataObject.HotelCode = e.target.value;
        //if (e.target.name === "AllowOutPolicy ") dataObject.AllowOutPolicy  = e.target.checked;

        //if (e.target.name === "CompanyName") dataObject.CompanyName  = e.target.value;



        //alert(e.target.name);

        if (e.target.name === "Role") {
            dataObject.RoleList[e.target.id].IsSelect = e.target.checked;
        }

        if (e.target.name === "CostCenterId") dataObject.CostCenterId = e.target.value;

        if (e.target.name === "PolicyId") dataObject.PolicyId = e.target.value;

        if (e.target.name === "EmployeeGroupId") dataObject.EmployeeGroupId = e.target.value;

        if (e.target.name === "Enable") dataObject.IsEnable = e.target.checked;

        if (e.target.name === "Email"){
            //dataObject.Email = utils.cleanString(e.target.value);
            dataObject.Email = e.target.value;
        }
        if (e.target.name === "Phone"){
            //dataObject.Phone = utils.cleanString(e.target.value);
            dataObject.Phone = e.target.value;
        }
        if (e.target.name === "FirstName"){
            //dataObject.FirstName = utils.cleanString(e.target.value);
            dataObject.FirstName = e.target.value;
        }
        if (e.target.name === "LastName"){
            //dataObject.LastName = utils.cleanString(e.target.value);
            dataObject.LastName = e.target.value;
        }
        if (e.target.name === "Password"){
            //dataObject.Password = utils.cleanString(e.target.value);
            dataObject.Password = e.target.value;
        }
        if (e.target.name === "ConfirmPassword") {
            //dataObject.ConfirmPassword = utils.cleanString(e.target.value);
            dataObject.ConfirmPassword = e.target.value;
        }
        this.setState({
            dataObject: dataObject,
        })
    }
    handleClick = (e) => {
        //alert("Update");
        //console.log(e);
        if (e.target.name === "Update") {
            this.callSetData();
        }
        if (e.target.name === "Delete") {
            this.callDeleteData();
        }
        // if(method === "Update"){
        //     alert("Update");
        // }
    }

    // renderNameInput(dataObject, validateObject) {
    //     let item = [];

    //     //console.log("debug");
    //     //console.log(dataObject);

    //     for (let i = 0; i < dataObject.HotelNameList.length; i++) {
    //         let label = "Hotel Name (" + dataObject.HotelNameList[i].LanguageCode + ")";
    //         item.push(
    //             <div className={style.sectionInput} key={i}>
    //                 <TextBoxWithLabel name="Name" id={i} key={i} label={label} value={dataObject.HotelNameList[i].Name} errorMessage={validateObject.HotelNameList[i].Name} onChange={this.handleChange} />
    //             </div>
    //         );
    //     }
    //     return item;
    // }
    render() {
        let result = [];
        let dataObject = this.state.dataObject;
        //let policyOptions = this.state.policyOptions;
        //let costcenterOptions = this.state.costcenterOptions;
        let employeeGroupOptions = this.state.employeeGroupOptions;
        let validateObject = this.state.validateObject;

        if (dataObject != null && employeeGroupOptions != null) {
            //let rowNameInput = this.renderNameInput(dataObject, validateObject);
            //alert(this.props.Id);



            //console.log(dataObject);


            let requirePassword = "";

            if(dataObject.Id == null){
                requirePassword = "*";
            }


            result = (
                <div className={style.createArea}>
                    <BackDropLoading show={this.state.loading} />
                    <div className={style.contentBox}>

                        {this.props.method === "Create" &&
                            <div className={style.contentTitle}>Create User</div>
                        }
                        {this.props.method === "Edit" &&
                            <div className={style.contentTitle}>Edit Company</div>
                        }
                        {this.props.method === "Delete" &&
                            <div className={style.contentTitle}>Delete Company</div>
                        }






                        <div className={style.line}></div>


                        <div className={style.rowInput}>
                            <CheckBoxWithLabel name="Enable" label="Active" value={dataObject.IsEnable} errorMessage="" onChange={this.handleChange} />
                        </div>



                        {/* <div className={style.rowInput}>
                            <CheckBoxWithLabel name="AllowOutPolicy " label="Allow Out Policy " value={dataObject.AllowOutPolicy } errorMessage="" onChange={this.handleChange} />
                        </div> */}




                        <div className={style.sectionInput}>
                            <DropDownWithLabel name="EmployeeGroupId" placeholder="none" label="User Group" options={this.state.employeeGroupOptions} value={dataObject.EmployeeGroupId} errorMessage={validateObject.EmployeeGroupId} onChange={this.handleChange} />
                        </div>


                        {/* <div className={style.sectionInput}>
                            <DropDownWithLabel name="CostCenterId"  placeholder="none" label="CostCenter" options={this.state.costcenterOptions} value={dataObject.CostCenterId} errorMessage={validateObject.CostCenterId} onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput}>
                            <DropDownWithLabel name="PolicyId"  placeholder="none" label="Policy" options={this.state.policyOptions} value={dataObject.PolicyId} errorMessage={validateObject.PolicyId} onChange={this.handleChange} />
                        </div> */}


                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="Email" label="Email*" value={dataObject.Email} errorMessage={validateObject.Email} onChange={this.handleChange} />
                        </div>



                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="FirstName" label="FirstName*" value={dataObject.FirstName} errorMessage={validateObject.FirstName} onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="LastName" label="LastName*" value={dataObject.LastName} errorMessage={validateObject.LastName} onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="Phone" label="Tel*" value={dataObject.Phone} errorMessage={validateObject.Phone} onChange={this.handleChange} />
                        </div>



                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="Password" label={"Password"+requirePassword} value={dataObject.Password} errorMessage={validateObject.Password} onChange={this.handleChange} />
                        </div>

                        <div className={style.sectionInput}>
                            <TextBoxWithLabel name="ConfirmPassword" label={"Confirm Password"+requirePassword} value={dataObject.ConfirmPassword} errorMessage={validateObject.ConfirmPassword} onChange={this.handleChange} />
                        </div>






                        <div className={style.rowInput}>
                            <MultipleCheckedWithLabel key={uuid} name="Role" label="Role" value={dataObject.RoleList} errorMessage={validateObject.RoleList} onChange={this.handleChange} />
                        </div>









                        <div className={style.btnRow}>
                            <div className={style.btnRowCenter}>


                                {this.props.method === "Create" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                    </div>
                                }
                                {this.props.method === "Edit" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                    </div>
                                }
                                {this.props.method === "Delete" &&
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Delete" onClick={this.handleClick} name="Delete" type="danger" />
                                    </div>
                                }
                                <div className={style.primaryBoxBtn}>
                                    <DefaultBtn label="Back" onClick={this.props.onClose} name="Back" type="default" />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            );
        }
        return result;
    }
}
export default CompanyUserControlUpdate;